module.exports = __webpack_public_path__ + "img/88.2bd641e.png";